<template>
  <div>
    <h4 class="text-center" style="margin-bottom: 30px;">Crea SUBS</h4>
      <b-card-group deck>
      <b-col lg="4" class="my-1">
        
        <b-card
          label="Cliente"
          label-cols-sm="12"
          label-size="sm"
          class="mb-0"
        >
          <ul>
            <li>
              Cliente: {{ userFullName }}
            </li>
            <li>
              Cane: {{ dogName }}
            </li>
            <li>
              Razza: {{ dogBreed }}
            </li>
            <li>
              Taglia/Pelo: {{ dogSize }}/{{ dogHair }}
            </li>
            <li>
              Gruppo SELF: {{ headerWashGroup }}
            </li>
          </ul>
          <!-- <b-form-group
            label="Seleziona Gruppo SELF"
            label-cols-sm="12"
            label-size="sm"
            class="mb-0"
          > 
            <b-form-select 
              id='filter-input' 
              v-model="headerWashGroup" 
              :options="washGroupOptions" 
              type="text"
            >
            </b-form-select>
          </b-form-group> -->
        </b-card>
      </b-col>
      <b-col lg="8" class="my-1">
        <b-card no-body class="overflow-hidden" style="max-width: 800px;">
          <b-row no-gutters>
            <b-col md="6">
              <b-card-img src="../../assets/cuccioli.png" alt="Image" class="rounded-0" style="max-width: 80%;"></b-card-img>
            </b-col>
            <b-col md="6">
              <b-card-body title="Carrello">
                <b-card-text>
                  <ul>
                    <!-- <li v-for="cartItem in cartItems" :key="cartItem.priceId">
                      {{ cartItem.productName }} <span style="float: right">{{ cartItem.discPrice }}</span>
                    </li> -->
                    <li v-for="product in selected" :key="product.price.id">
                      {{ product.name }} <span style="float: right">{{ (product.price.net / 100).toFixed(2) }} €</span>
                    </li>
                  </ul>
                  <hr>
                  Totale: <span style="float: right">{{ (total / 100).toFixed(2) }} €</span>
                </b-card-text>
              </b-card-body>
              <b-card-footer>
                <b-button size="sm" @click="subscribe" style="float: right">
                  SALVA
                </b-button>
              </b-card-footer>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-card-group>
    
    <b-table
      striped 
      hover 
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc" 
      :items="items" 
      :filter="headerWashGroup"
      :filter-included-fields="filterOn"
      :filter-function="filterTable"
      stacked="md"
      show-empty
      small
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable
      no-select-on-click
      selected-variant="success"
      @row-selected="onRowSelected"
      @filtered="onFiltered"
    >
      <template #thead-top="">
        <b-tr>
          <b-th colspan="3"><span class="sr-only">Pacchetto & Gruppo SELF & Lavaggi</span></b-th>
          <b-th variant="secondary" colspan="2" class="text-center">Listino</b-th>
          <b-th variant="primary" colspan="2" class="text-center">Sconto</b-th>
          <b-th variant="secondary" colspan="2" class="text-center">Netto</b-th>
          <b-th colspan="1"><span class="sr-only">Azioni</span></b-th>
        </b-tr>
      </template>
      <template #cell(actions)="row">
        <!-- <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Info modal
        </b-button> -->
        <!-- <b-button size="sm" @click="row.toggleDetails" style="margin-right: 10px;">
          {{ row.detailsShowing ? '-' : '+' }} Dettaglio
        </b-button> -->
        <b-button v-if='isRowSelected[row.index]' size="sm" @click="toggleCart(row.index)" class="mr-1" variant="secondary">
          - Rimuovi
        </b-button>
        <b-button v-else size="sm" @click="toggleCart(row.index)" class="mr-1 dark" variant="dark">
          + Aggiungi
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>

    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only ok-title="CHIUDI"
      ok-variant="secondary" @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>

  </div>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import { mapGetters, mapMutations } from 'vuex';
  import axios from 'axios';
  //import { HTTP } from '../../api/http-common.js';

  const taxRates = ['txr_1Hcaj6GYamFGTSLwAyRk0JIK'];
  //let productArray = [];
  
  export default {
    data() {
      return {
        isBusy: false,
        isRowSelected: [],
        userId: '',
        userFullName: '',
        dogId: '',
        dogName: '',
        dogBreed: '',
        dogSize: '',
        dogHair: '',
        dogWashPgm: '',
        headerWashGroup: '',
        washGroupOptions: [
          { value: '11', text: 'XS/S' },
          { value: '12', text: 'XS/M' },
          { value: '13', text: 'XS/L' },
          { value: '21', text: 'S/S' },
          { value: '22', text: 'S/M' },
          { value: '23', text: 'S/L' },
          { value: '31', text: 'M/S' },
          { value: '32', text: 'M/M' },
          { value: '33', text: 'M/L' },
          { value: '41', text: 'L/S' },
          { value: '42', text: 'L/M' },
          { value: '43', text: 'L/L' },
          { value: '51', text: 'XL/S' },
          { value: '52', text: 'XL/M' },
          { value: '53', text: 'XL/L' },
          { value: '61', text: 'XXL/S' },
          { value: '62', text: 'XXL/M' },
          { value: '63', text: 'XXL/L' } 
        ],
        sortBy: 'WashTot',
        sortDesc: false,
        fields: [
          { key: 'name', label: 'Pacchetto' }, 
          { key: 'WashGroup', 
            label: 'Gruppo Self', 
            sortable: true, 
            sortByFormatted: true,
            filterByFormatted: true, 
            class: 'text-center' 
          },
          { key: 'WashTot', 
            label: 'Lav./anno',
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true, 
            class: 'text-center' 
          },
          { key: 'price.listUnit', 
            label: 'unit',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.list', 
            label: 'package',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.discountType', 
            label: 'tipo', 
            class: 'text-center' 
          },
          { key: 'price.discount', 
            label: '%',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'percent',
              }).format(value.toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.netUnit', 
            label: 'unit',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.net', 
            label: 'package',
            // formatter: (value, key, item) => {
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'actions', label: 'Azioni' }
        ],
        items: [],
        modes: ['single', 'multi', 'range' ],
        selectMode: 'multi',
        row: {},
        selected: [],
        filter: null,
        filterOn: ['WashGroup'],
        totalRows: 1,
        sortDirection: 'asc',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
      }
    },
    methods: {
      onRowSelected(items) {
        this.selected = items
        console.log('selected.lenght AFTER selection', this.selected.lenght)
      },
      toggleCart(index) {
        if(this.isRowSelected[index]) {
          this.isRowSelected[index] = false
          console.log('selected.lenght BEFORE -', this.selected.lenght)
          this.$refs.selectableTable.unselectRow(index)
          console.log('selected.lenght AFTER -', this.selected.lenght)
        } else {
          this.isRowSelected[index] = true
          console.log('selected.lenght BEFORE +', this.selected.lenght)
          this.$refs.selectableTable.selectRow(index)
          console.log('selected.lenght AFTER +', this.selected.lenght)
        }
      },
      filterTable(row, filter) {
        if (row.WashGroup == filter || row.WashGroup == '99') {
          return true;
        } else {
          return false;
        }
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      /*showModal(title, message) {
        console.log('fase3-SUBS finita, Card-UID ->', id)
        this.my-modal.content = message
        this.$refs['my-modal'].show()
      },
      hideModal() {
        this.$refs['my-modal'].hide()
        this.$router.push({name:'dashboard'})
      },*/
      info(title, message) {
        this.infoModal.title = title
        this.infoModal.content = message
        this.$root.$emit('bv::show::modal', this.infoModal.id)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
        //this.$router.push({name:'dashboard'})
        this.items = []
        this.$router.push({name:'user_detail'})
      },
      createSubsEvent(subsItems, cardSubsItem, subsHistoryItems, subs) {
        //localhost baseURL
        //let route = 'http://localhost:5001/dogmoticswebapp/us-central1/webApi/api/v1/access/'; 
        //remote baseURL
        let route = 'https://us-central1-dogmoticswebapp.cloudfunctions.net/webApi/api/v1/access/';
        //adding further params: eg. mi1/BX01/ev37/C4332437/0/3000'
        route = route + this.auth_user.data.storeId + '/' //added storeId parameter
        route = route + 'AA01' + '/' //added device code = Admin App
        if((subsItems == 0) && (subsHistoryItems == 0)) {
          route = route + 'ev33' + '/' //added event code = new subscription
        } else {
          route = route + 'ev35' + '/' //added event code = renewal
        }
        route = route + this.sel_card.uid + '/' //added card UID
        route = route + cardSubsItem + '/' //added subsItem
        route = route + subs.price.net.toString() + '/' //added net price
        route = route + subs.price.list.toString() + '/' //added list price
        route = route + subs.WashTot.toString() //added tot Wash

        axios.get(route, {
          headers: {
            Authorization: 'Bearer {1gO7et4Nx7SIMGkf51ZK8kTUqnAQj1j7y39geoAc}'
          }
        })
        .then(response => {
          if(response.ok) console.log('Event created', response)
        })
        .catch((err) => {
          //Display error
          console.log(err.message, err)
          this.info('Errore!', err.message);
        })
      },
      async subscribe(event) {
        event.preventDefault();

        const subsItems = this.sel_card.data.subsItems // actual active subsItems on the card
        let totActiveSubs = subsItems + this.selected.length
        console.log('selected.lenght / subsItems', this.selected.lenght, subsItems)
        if (totActiveSubs > 3) {
          this.infoModal.title('Superato numero max. SUBs attive')
          this.selected = []
          return  // SUBs not created in case of potential active SUBs greater than 3
        }
        
        const selUser = this.userId //ex 'dOm1neUT4SOORHAoqc5oMafAqv43'
        const selDog = this.dogId

        // LOOP cycle to add "i" new subscriptions on "subs" collection & updating accordingly the user's card

        var i;
        for (i = 0; i < this.selected.length; i++) {
          let X = subsItems + i + 1 // adding new subsItemX to selected card
          let subsItemX = 'subsItem' + X.toString()
          console.log('subsItemX ->', subsItemX)

          const subsDate = new Date(); // today
          let dueDate = new Date(); // today
          dueDate.setFullYear(dueDate.getFullYear() + 1) //dueDate=today + 1 year
          console.log('subsDate / dueDate ->', subsDate, dueDate)

          // add subs document to subscriptions subcollection
          db.collection('users')
          .doc(selUser)
          .collection('dogs')
          .doc(selDog)
          .collection('subs')
          .add({
            cardUid: this.sel_card.uid,
            cardSubsItem: subsItemX,
            active: true,
            price: this.selected[i].price, //all price Object: gross, net, discount, active, ...
            name: this.selected[i].name,
            WashTot: this.selected[i].WashTot,
            tax_rates: taxRates,
            metadata: {
              tax_rate: '22% IVA incl.',
            },
            exp_dt: dueDate,
            subs_dt: subsDate
          })
          .then((doc) => {
            //Save subs data into the state
            console.log('doc-path ->', doc.path);
            db.doc(doc.path).get()
            .then((doc) => {
              console.log('doc-SUBS ->', doc.data());
              this.set_sel_subs({id: doc.id, data: doc.data()});
              //Display success
              console.log('sel_subs ->', this.sel_subs);
              this.info('Registrazione OK', `Creata sottoscrizione ${this.sel_subs.id}`);
            });
          })
          .catch((err) => {
             //Display error
             console.log(err.message, err)
             this.info('Errore!', err.message);
          });

          console.log('selected[] ->', this.selected)

          const cardUid = this.sel_card.uid //'ABC12300'
          const card = {
            active: true, // boolean
            //role: 3, // 3 = customer
            subsItems: subsItems + i + 1, // number => 1 || 2 || 3
            [subsItemX]: {
              dogRef: this.dogId,
              DogName: this.dogName,
              DogBreed: this.dogBreed,
              DogSize: Number(this.dogSize), // number => 1 || 2 || 3 || 4 || 5 || 6
              DogHair: Number(this.dogHair), // number => 1 || 2 || 3
              WashPgm: this.selected[i].WashGroup.toString(), // string => "11" -> "99"
              WashAct: 0, // number => 0 -> WashTot
              WashTot: Number(this.selected[i].WashTot), // Tot.Washes per Year || before Exp.Date
              SubsName: this.selected[i].shortName,
              DueDate: dueDate.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }), // dueDate in string format => DD/MM/YYYY)
              SubsDate: subsDate.toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }) // subsDate in string format => DD/MM/YYYY)
            }
          };

          console.log('subsCreate - card ->', card)
          const cardSubsItem = X.toString()
          db.collection('cards')
          .doc(cardUid)
          //.set(card, {merge: true})
          .update(card)
          .then(() => {
            //Save card<< data into the state
            db.collection('cards')
            .doc(cardUid).get()
            .then((doc) => {
              console.log('doc-CARDS ->', doc.data());
              this.set_sel_card({uid: doc.id, data: doc.data()});
              const docData = doc.data();
              const subsHistoryItems = docData.subsHistoryItems !== undefined 
                ? docData.subsHistoryItems 
                : 0;
              //create subscription event (new subs || renewal)
              this.createSubsEvent(subsItems, cardSubsItem, subsHistoryItems, this.sel_subs.data);
              //Display success
              console.log('sel_card ->', this.sel_card);
              this.info('Registrazione OK', `Creata/aggiornata CARD ${this.sel_card.uid}`);
            });
          })
          .catch((err) => {
             //Display error
             console.log(err.message, err)
             this.info('Errore!', err.message);
          });
        }
      },

        /*document.querySelectorAll('button').forEach((b) => (b.disabled = true));
        const formData = new FormData(event.target);
        const selUser = this.sel_user.data.id;

        const docRef = await db
          .collection('users')
          .doc(selUser)
          .collection('checkout_sessions')
          .add({
            price: formData.get('price'),
            allow_promotion_codes: true,
            tax_rates: taxRates,
            success_url: window.location.origin,
            cancel_url: window.location.origin,
            metadata: {
              tax_rate: '22% IVA incl.',
            },
          });
        // Wait for the CheckoutSession to get attached by the extension
        docRef.onSnapshot((snap) => {
          const { error, sessionId } = snap.data();
          if (error) {
            // Show an error to your customer and then inspect your function logs.
            alert(`An error occured: ${error.message}`);
            document.querySelectorAll('button').forEach((b) => (b.disabled = false));
          }
          console.log(sessionId)
          if (sessionId) {
            // We have a session, let's redirect to Checkout
            // Init Stripe
            const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
            stripe.redirectToCheckout({ sessionId });
          }
        });
      },*/
      ...mapMutations({
        set_sel_dog: 'SET_SEL_DOG', // map `this.set_sel_dog()` to `this.$store.commit('SET_SEL_DOG')`
        set_sel_subs: 'SET_SEL_SUBS',
        set_sel_card: 'SET_SEL_CARD',
      }),
    },
    computed: {
       ...mapGetters({
          // map `this.***` to `this.$store.getters.***`
          auth_user: "user",
          sel_user: "_user",
          // map `this.sel_dog` to `this.$store.getters._dog`
          sel_dog: "_dog",
          sel_subs: "_subs",
          sel_card: "_card",
       }),
       total () {
        let totActiveSubs = this.selected.length + this.sel_card.data.subsItems
        if (totActiveSubs < 4) {
          return this.selected.reduce( (acc, product) => {
            return acc + (product.price.net)
          }, 0)
        }
        else {
          alert('Superato numero max. SUBs attive')
          console.log('Superato numero max. SUBs attive selected.lenght / subsItems', this.selected.length, this.sel_card.data.subsItems)
          return 0
        }
        
      },
    },
    created() {
      // Header data
      console.log('sel_user ->', this.sel_user)
      console.log('sel_dog ->', this.sel_dog)
      console.log('sel_card ->', this.sel_card)

      if(!this.sel_user.data || !this.sel_dog.data) {
        alert('Errore: parametri di stato (user / dog) non assegnati')
        return
      }

      this.userId = this.sel_user.data.id //'dOm1neUT4SOORHAoqc5oMafAqv43',
      this.userFullName = this.sel_user.data.fullName
      this.userDisplayName = this.sel_user.data.displayName
      this.dogId = this.sel_dog.id
      this.dogName = this.sel_dog.data.name //'CAMILLO',
      this.dogBreed = this.sel_dog.data.breedName //'Basset Hound',
      this.dogSize = this.sel_dog.data.size //'L',
      this.dogHair = this.sel_dog.data.hair //'M',
      this.dogWashPgm = this.sel_dog.data.washPgm //'41',
      //this.filter = this.dogWashPgm
      this.headerWashGroup = this.dogWashPgm

      // Row data
      this.items = []
      db.collection('products')
      .where('active', '==', true)
      .where('stripe_metadata_WashGroup', 'in', [this.dogWashPgm, '99'])
      //.orderBy('stripe_metadata_WashGroup', 'asc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log('product->', doc.data())
          db.collection('washGroups')
          .where('orgId', '==', this.auth_user.claims.orgId)
          .where('washPgm', '==', doc.data().stripe_metadata_WashGroup)
          .get()
          .then((snapshot) => {
            snapshot.forEach((price) => {
              //console.log('price', price.data())
              const unitPrice = price.data().unitPrice
              const productWashTot = doc.data().stripe_metadata_WashTot
              const listPrice = unitPrice * productWashTot
              var discount = 0;
              switch(productWashTot) {
                case 4:
                  discount = 0;
                  break;
                case "7":
                  discount = 0.1;
                  break;
                case "9":
                  discount = 0.15;
                  break;
                case "12":
                  discount = 0.2;
                  break;
                default:
                  break;
              }
                   
              const product = {
                id: doc.id,
                name: doc.data().name,
                shortName: doc.data().shortName,
                description: doc.data().description,
                active: doc.data().active,
                DogSize: doc.data().stripe_metadata_Size,
                DogHair: doc.data().stripe_metadata_Hair,
                WashGroup: doc.data().stripe_metadata_WashGroup,
                WashTot: doc.data().stripe_metadata_WashTot,
                WashAct: 0,
                
                price: {
                  id: price.id,
                  listUnit: unitPrice,
                  list: listPrice,
                  discountType: 'pack',
                  discount: discount,
                  netUnit: Math.round(listPrice * (1 - discount) / productWashTot),
                  net: Math.round(listPrice * (1 - discount)),
                }
              }
              this.items.push(product);
            })
          })
        })
      })
      //console.log('this.items ->', this.items)
    },
  };

      /* OLD VERSION
      productArray = []
      db.collection('products')
      .where('active', '==', true)
      //.where('stripe_metadata_WashGroup', '==', this.dogWashPgm.toText())
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(async(doc) => {
          const priceSnap = await doc.ref
          .collection('prices')
          .orderBy('unit_amount')
          .get();

          const product = {
            id: doc.id,
            name: doc.data().name,
            shortName: doc.data().shortName,
            description: doc.data().description,
            active: doc.data().active,
            DogSize: doc.data().stripe_metadata_Size,
            DogHair: doc.data().stripe_metadata_Hair,
            WashGroup: doc.data().stripe_metadata_WashGroup,
            WashTot: doc.data().stripe_metadata_WashTot,
            WashAct: 0,
            
            price: {
              id: '',
              list: 0,
              discount: 0,
              net: 0,
              unitCost: 0,
            }
          }

          priceSnap.docs.forEach((doc) => {
            if(doc.data().active && 
              doc.data().interval == 'year') 
            {
              product.price.id = doc.id;
              product.price.list = doc.data().unit_amount;
              var discount = 0;
              switch(product.WashTot) {
                case 4:
                  discount = 0;
                  break;
                case "7":
                  discount = 0.1;
                  break;
                case "9":
                  discount = 0.15;
                  break;
                case "12":
                  discount = 0.2;
                  break;
                default:
                  break;
              }
              product.price.discount = discount; 
              product.price.net = Math.round(product.price.list * (1 - discount)); 
              product.price.unitCost = product.price.net / product.WashTot; 
              console.log('productSnap ->', product)
              productArray.push(product);
              //this.items.push(product);
            }
          })
        })
      });
      console.log('productArray ->', productArray);
      this.items = productArray;
      //console.log('this.items ->', this.items);
    },
  }; OLD END*/
            /*{
              const priceId = doc.id;
              const priceData = doc.data();
              const content = document.createTextNode(
                `${new Intl.NumberFormat('it-IT', {
                  style: 'currency',
                  currency: priceData.currency,
                }).format((priceData.unit_amount / 100).toFixed(2))} per ${
                  priceData.interval
                }`
              );*/

      /*db.collection('products')
      .onSnapshot((snapshotChange) => {
        this.products = [];
        snapshotChange.forEach((doc) => {
          const productId = doc.id;
          const productData = doc.data();
          //this.products.push(doc.data())
          console.log(this.products)
          const refPath = db.doc('products/' + productId);
          console.log(refPath);
          refPath.collection('prices')
          .onSnapshot((snapshotChange) => {
            this.prices = [];
            snapshotChange.forEach((doc) => {
              if(doc.data().active && 
                doc.data().interval == 'year') {

                const priceId = doc.id;
                const priceData = doc.data();
                const content = document.createTextNode(
                  `${new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: priceData.currency,
                  }).format((priceData.unit_amount / 100).toFixed(2))} per ${
                    priceData.interval
                  }`
                );


              }

              this.prices.push(doc.data())
              console.debug(this.prices)
            })  
          })
        })
      });*/
      /*// metodo DOM
      const products = document.querySelector('.products');
      const template = document.querySelector('#product');
      db.collection('products')
        //.where('active', '==', true && 'stripe_metadata_WashGroup', '==', '22')
        .where('stripe_metadata_WashGroup', '==', '22')
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            const priceSnap = await doc.ref
              .collection('prices')
              .orderBy('unit_amount')
              .get();
            if (!('content' in document.createElement('template'))) {
              console.error('Your browser doesn’t support HTML template elements.');
              return;
            }

            const product = doc.data();
            const container = template.content.cloneNode(true);

            container.querySelector('h2').innerText = product.name.toUpperCase();
            container.querySelector('.description').innerText =
              //product.description?.toUpperCase() || '';
              product.description?.toString() || '';
            // Prices dropdown
            priceSnap.docs.forEach((doc) => {
              const priceId = doc.id;
              const priceData = doc.data();
              const content = document.createTextNode(
                `${new Intl.NumberFormat('it-IT', {
                  style: 'currency',
                  currency: priceData.currency,
                }).format((priceData.unit_amount / 100).toFixed(2))} per ${
                  priceData.interval
                }`
              );
              const option = document.createElement('option');
              option.value = priceId;
              option.appendChild(content);
              container.querySelector('#price').appendChild(option);
            });

            if (product.images.length) {
              const img = container.querySelector('img');
              img.src = product.images[0];
              img.alt = product.name;
            }

            const form = container.querySelector('form');
            form.addEventListener('submit', this.subscribe());

            products.appendChild(container);
          });
        });*/
</script>

<style>
  .products {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(4, 1fr);
    margin-top: 3rem;
    margin-left: -50%;
  }

  .product img {
    width: 280px;
  }

  .product input {
    border: 1px solid #039be5;
    border-radius: 0.25rem;
    font-size: 1.125rem;
    line-height: 1.25rem;
    padding: 0.25rem;
  }
</style>
